import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import GeneralInfoEntry from "../../panels/generalInfo/components/GeneralInfoEntry";
import OfferInput from "./inputs/OfferInput";


function OfferPositionParameters(
    {
        formikProps,
        parameters,
        priceType,
        disabled
    }) {

    if (parameters.length === 0)
        return null;

    return (
        <GeneralInfoEntry biggerLabel label={Tr('parameters')} collapsible defaultCollapsed={false}>
            {
                parameters.map((parameter, index) => (
                    <OfferInput
                        key={parameter.criterium.identity}
                        id={`parameters.${index}`}
                        criterion={parameter}
                        formikProps={formikProps}
                        priceType={priceType}
                        disabled={disabled}
                    />
                ))}
        </GeneralInfoEntry>)

}

OfferPositionParameters.propTypes = {
    parameters: PropTypes.array.isRequired
}

export default OfferPositionParameters;